import tracking from '../lib/tracking';
import global from './global';
import '../../vendor/jquery.shorten';
import { v4 } from 'uuid';

export default function() {
    $(function() {
        global();

        let stats = getStats();
        $('.j-click').each(function(_idx, item) {
            $(item).attr('href', $(item).attr('href') + stats);
        });
        let img = $(document.createElement('img'));
        img.attr('src', $('.j-imp').attr('data-src') + stats);
        img.addClass('hide');
        img.appendTo('body');

        // price see more
        $('.content').on('click', '.td-price .hyperlink', function () {

            $(this).closest('ul').find('li').removeClass('hide');
            $(this).parent().remove();
        });

        // desc show more
        $('td .td-description').shorten();
        // reference show more
        $('.reference-description').shorten();

        // tracking - More Info link (to expand ref design description) on SRP
        // changed to tracking for FFF #907
        $('.reference-description .morelink').on('click', function () {

            let $holder = $(this).parents('.reference-description');

            tracking.ckEventUrl($holder.attr('data-url'));
            tracking.recordUserClick('FFF', 'MoreDescription', 'SRP');
        });

        $('.expand-details').on('click', function() {
            let $this = $(this);
            let $row = $this.parents('.row');
            if ($this.find('.arrow-right').length) {
                $row.find('.td-price-range').addClass('hide');
                $row.find('.td-desc').addClass('visible');
                $row.find('.td-price').addClass('visible');
                $this.find('.arrow-right').addClass('arrow-bottom').removeClass('arrow-right');
            } else {
                $row.find('.td-price-range').removeClass('hide');
                $row.find('.td-desc').removeClass('visible');
                $row.find('.td-price').removeClass('visible');
                $this.find('.arrow-bottom').addClass('arrow-right').removeClass('arrow-bottom');
            }
        });

        if ($('.no-results').length) {
            $('head').append('<meta name="robots" content="noindex, follow">');
        }
    });
}

function getStats() { 
    let val  = '';
    const canvas = document.createElement('canvas');
    const features = [window.self !== window.top, navigator.webdriver, !navigator.plugins?.length, !navigator.languages?.length, navigator.mimeTypes?.length, /HeadlessChrome|PhantomJS|puppeteer/.test(navigator.userAgent), window.outerWidth === 0 && window.outerHeight === 0, !canvas.getContext('webgl') && !canvas.getContext('experimental-webgl'), !window.RTCPeerConnection, window.Proxy && window.Proxy.toString().indexOf('function Proxy()') > -1];
    for (let item of features) {
        if (item) {
            val += '1';
        } else {
            val += '0';
        }
    }

    const start = performance.now();
    for (let i = 0; i < 999999; i++) { 
        // do nothing
    }
    const duration = Math.round((performance.now() - start) * 100) / 100;

    val = parseInt(val, 2); 
    return `&t=${val.toString(16)}&p=${encodeURIComponent(duration)}&c=${encodeURIComponent(v4())}`;
} 